import { atom, RecoilState } from 'recoil';

export const navigationSettingsState = atom({
  key: 'navigationSettingsState',
  default: {
    titleEnabled: false,
    title: '',
    navbarCustomColorsEnabled: false,
    navbarBgColor: '',
    navbarTextColor: '',
    navbarButtonPrimaryColor: '',
    navbarButtonSecondaryColor: '',
    navbarPathColor: '',
    sortingEnabled: true,
    defaultSorting: 'default',
    descriptionEnabled: false,
    filtersEnabled: true,
    webContentEnabled: true,
    webThumbnailEnabled: true,
    teleportButtonEnabled: false,
    autoMoveButtonEnabled: true,
    autoPlayEnabled: true,
    detailedRouteEnabled: false,
  },
});

export const navigationFinishScreenState = atom({
  key: 'navigationFinishScreenState',
  default: {
    ratingEnabled: true,
    beforeVoteText: '',
    afterVoteText: '',
    sharingEnabled: true,
    popupTitle: 'Get your route on your phone!',
    qrEnabled: true,
    qrTitle: 'Scan this QR Code',
    smsEnabled: false,
    smsTitle: '',
    smsText: '',
  },
});

export const sliderValueState = atom({
  key: 'sliderValueState',
  default: 0,
});

export const navigationToastState = atom({
  key: 'navigationToastState',
  default: false,
});

export const navigationTranslationState: RecoilState<{ [key: string]: string }> = atom({
  key: 'navigationTranslationState',
  default: {},
});
